export function removeAt(array, index) {
    array.splice(index, 1);
};

export function removeValue(array, item) {
    let index;
    while(array.length > 0 && (index = array.indexOf(item)) >= 0)
        removeAt(array, index);
};

export function removeAny(array, predicate) {
    let index;
    while(array.length > 0 && (index = array.findIndex(predicate)) >= 0)
        removeAt(array, index);
};

export function shuffle(array) {
    if(array.length < 2)
        return;

    for(let i = array.length - 1; i > 0; --i) {
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
};
